import React, { Component } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { Table, TableCell, TextIcon, TableHeader, TableLoading,
  Title, Colors, Button, Pagination } from 'advenio-components'
import { connect } from 'react-redux'
import ReminderActions from '../../Data/Redux/PaymentRemindersRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'

const TableContainer = styled.div`
  box-shadow: 1px 1px 16px 0px rgba(0,0,0, .3);
  border-radius: 4px;
`
const InfoCell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  font-size: 12px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
`
const StudentName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: ${Colors.blue500};
  cursor: pointer;
`
const ParentName = styled.span`
  margin-left: 4px;
  color: ${Colors.gray800}
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const Container = styled.div`
  padding: 32px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`

class ReminderContainer extends Component {
  state = {
    firstPageToRender: 1,
    lastPageToRender: 10,
    pageSelected: 1,
  }

  componentWillMount() {
    const { getClassrooms, getReminders, location, user } = this.props
    const queryParams = queryString.parse(location.search)

    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }

    this.setState({ queryParams })

    getReminders(user.center_id, { ...queryParams })
    // getClassrooms()
  }

  onClickPage = (pageSelected) => {
    const { getReminders, goTo, user } = this.props

    this.setState({ pageSelected }, () => {
      const queries = { page: pageSelected }

      getReminders(user.center_id, queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  getClassroom = (id) => {
    const selectedClassroom = this.props.classrooms.find(c => c.id === id)
    return selectedClassroom ? selectedClassroom.name : ''
  }

  sendOneReminder = id => () => {
    this.props.sendReminder(id)
  }

  sendAllReminders = () => {
    this.props.sendAllReminders(this.props.user.center_id)
  }

  navigateToProfile = (student) => {
    const { goTo, setActiveStudentId, setActiveClassroomId } = this.props
    const { classroom_id: classroomId, id: studentId } = student

    setActiveStudentId(Number(studentId))
    setActiveClassroomId(Number(classroomId))

    return goTo(`/classroom/${classroomId}/student/${studentId}`)
  }

  isDisabled = () => {
    const { reminders } = this.props
    let count = 0

    for (let i = 0; i < reminders.length; i += 1) {
      if (reminders[i].last_sent_at) {
        count += 1
      }
    }

    return count === reminders.length
  }

  render() {
    const { loading, meta, reminders } = this.props
    const { pageSelected } = this.state

    return (
      <Container>
        <HeaderContainer>
          <Title>Recordatorios</Title>
          <Button
            primary
            marginRight="0"
            disabled={this.isDisabled()}
            onClick={this.sendAllReminders}
          >
            Recordar a todos
          </Button>
        </HeaderContainer>
        <PaginationContainer>
          <Pagination
            totalElements={meta && meta.total}
            elementsPerPage={meta && meta.per_page}
            onPageClick={this.onClickPage}
            pageSelected={pageSelected}
          />
        </PaginationContainer>
        {loading ?
          <TableLoading
            roundedCorners
            columns={[
              {
                id: 1,
                header: '# de Cuenta',
                element: 'Text',
                center: true,
                maxWidth: 150,
              },
              {
                id: 2,
                header: 'Alumno',
                element: 'Text',
              },
              {
                id: 3,
                header: 'Sala',
                element: 'Text',
                center: true,
                maxWidth: 150,
              },
              {
                id: 4,
                header: 'Saldo Pendiente',
                element: 'Text',
                center: true,
                maxWidth: 300,
              },
              {
                id: 5,
                header: '',
                element: 'Text',
                maxWidth: 200,
              },
            ]}
            rows={10}
          /> :
          <TableContainer>
            <Table
              roundedCorners
              data={reminders}
              columns={[
                {
                  id: 1,
                  Header: () => <TableHeader title="# de cuenta" blue center />,
                  accessor: ({ id }) => id,
                  Cell: ({ value: id }) => <TableCell center>{id}</TableCell>,
                  maxWidth: 150,
                },
                {
                  id: 2,
                  Header: () => <TableHeader title="Alumno" blue />,
                  accessor: ({ student, parent }) => ({ student, parent }),
                  Cell: ({ value: { student, parent } }) => (
                    <TableCell >
                      <InfoCell>
                        <InfoRow>
                          <StudentName onClick={() => this.navigateToProfile(student)}>
                            {student && student.name}
                          </StudentName>
                        </InfoRow>
                        <InfoRow>
                          Tutor: <ParentName>{parent && parent.name}</ParentName>
                        </InfoRow>
                      </InfoCell>
                    </TableCell>
                  ),
                },
                {
                  id: 3,
                  Header: () => <TableHeader title="Sala" blue center />,
                  accessor: ({ student }) => student,
                  Cell: ({ value: student }) =>
                    <TableCell center>{this.getClassroom(student.classroom_id)}</TableCell>,
                  maxWidth: 150,
                },
                {
                  id: 4,
                  Header: () => <TableHeader title="Saldo Pendiente" blue center />,
                  accessor: ({ formatted_balance: total }) => total,
                  Cell: ({ value }) => <TableCell center>{value}</TableCell>,
                  maxWidth: 300,
                },
                {
                  id: 5,
                  Header: () => <TableHeader blue />,
                  accessor: ({ student, last_sent_at }) => ({ student, last_sent_at }),
                  Cell: ({ value: { student, last_sent_at } }) => (
                    <TableCell center >
                      {last_sent_at ?
                        <ValidatedText
                          label="Recordatorio Enviado"
                          iconType="checkmark"
                          iconViewBox="0 1 18 18"
                          iconColor={Colors.green500}
                        /> :
                        <Button
                          small
                          success
                          onClick={this.sendOneReminder(student.id)}
                        >
                          Recordatorio
                        </Button>
                      }
                    </TableCell>
                  ),
                  maxWidth: 200,
                },
              ]}
            />
          </TableContainer>
        }
      </Container>
    )
  }
}

ReminderContainer.propTypes = {
  /** A listing of all classrooms in the current center */
  classrooms: PropTypes.array,
  /** Loading flag */
  loading: PropTypes.bool.isRequired,
  /** React router location information, containing query params etc. */
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  /** Meta data for the paginated results */
  meta: PropTypes.object,
  /** An array of pending payment reminders */
  reminders: PropTypes.array,
  /** The authenticated user */
  user: PropTypes.object.isRequired,

  /** Fetch a listing of all classrooms */
  getClassrooms: PropTypes.func.isRequired,
  /** Fetch a listing of all student's with outstanding debt */
  getReminders: PropTypes.func.isRequired,
  /** Submit a request to the API to send a payment reminder to the given student's parents */
  sendReminder: PropTypes.func.isRequired,
  /** Submit a request to the API to send all pending payment reminders */
  sendAllReminders: PropTypes.func.isRequired,
  /** Set the active student ID in the state */
  setActiveStudentId: PropTypes.func.isRequired,
  /** Set the active classroom ID in the state */
  setActiveClassroomId: PropTypes.func.isRequired,
  /** Navigate to the given URI */
  goTo: PropTypes.func.isRequired,
}

ReminderContainer.defaultProps = {
  classrooms: [],
  meta: {},
  location: {},
  reminders: [],
}

const mapStateToProps = ({ auth, classrooms, payment_reminders }) => ({
  classrooms: classrooms.get.results,
  loading: payment_reminders.get.fetching,
  meta: payment_reminders.get.results.meta,
  reminders: payment_reminders.get.results.data,
  user: auth.user,
})

const mapDispatchToProps = dispatch => ({
  sendReminder: studentId => dispatch(ReminderActions.sendOneRequest(studentId)),
  sendAllReminders: centerId => dispatch(ReminderActions.sendAllRequest(centerId)),
  getReminders: (centerId, queries) =>
    dispatch(ReminderActions.getAllRequest(centerId, queries)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  getClassrooms: () => dispatch(ClassroomActions.getRequest()),
  goTo: path => dispatch(push(path)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReminderContainer)



// WEBPACK FOOTER //
// ./src/Containers/PaymentReminders/PaymentReminders.jsx